export default __webpack_public_path__ + "static/media/projects1.74c78372.jpg";